import { hasValue } from 'swipeclock-frontend';
import { target } from 'lib/router';

export default function transformer(evaluator) {
  // Helper method for joining arrays back together
  // Depending on if the item is filtered
  function stitchArray(show) {
    return (head, item, tail) =>
      show ? [...head, item, ...tail] : [...head, ...tail];
  }

  // If item.url, we need to add anchor to item,
  // otherwise, we can just leave it "as is".
  function improveAnchor(item) {
    if (item.url) {
      return {
        ...item.anchor,
        target: target.self,
        url: item.url,
        // If this is set, it'll attempt to route
        // by sending an event to iframe so it can
        // handle its own client-side routing change.
        routeViaEvent: item.routeViaEvent ?? false,
      };
    }

    return item.anchor;
  }

  // Helper method to traverse each array within
  // the main drawer object
  function transformArray(parentItem, array, index = 0, parentKeys = []) {
    if (!hasValue(array[index])) {
      return array;
    }

    const item = array?.[index];
    const showItem = evaluator?.checkIfDrawerItemIncluded(item, array);
    const stitch = stitchArray(showItem);

    // Build out the array's head and tail
    // To be used in stitching the array back
    // together again
    const hasTail = index + 1 < array.length;
    const tail = hasTail ? array.slice(index + 1) : [];
    const isHead = index === 0;
    const head = isHead ? [] : array.slice(0, index);

    // Update the index only if the item should be
    // shown in the drawer
    const newIndex = showItem ? index + 1 : index;
    const key = `${parentItem?.key ?? ''}//${item.text.toLowerCase()}`;

    const itemWithKey = {
      ...item,
      key,
      anchor: improveAnchor(item),
      parentKeys,
    };

    if (hasValue(item?.items)) {
      // If children then drill down into the child's array
      // And then stitch things back together with new array
      const newChildren = transformArray(itemWithKey, item?.items, 0, [
        ...parentKeys,
        key,
      ]);
      const newItem = { ...itemWithKey, items: newChildren };
      const newArray = stitch(head, newItem, tail);
      return transformArray(newItem, newArray, newIndex, parentKeys);
    }

    // If no children then stitch together the array
    // based on if the item should be shown or not.
    const newArray = stitch(head, itemWithKey, tail);
    return transformArray(itemWithKey, newArray, newIndex, parentKeys);
  }

  // Main method to call
  // reduces drawer and for each
  // array calls transformArray to
  // filter out unwanted drawer items
  function transform(drawer) {
    if (!hasValue(drawer)) {
      return null;
    }

    return Object.keys(drawer).reduce((prev, key) => {
      const itemArray = drawer?.[key];
      return { ...prev, [key]: transformArray(null, itemArray) };
    }, {});
  }

  return {
    transform,
  };
}
